import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/remote-call';
import { useSkipEffectOnMount } from '@hooks/lifecycle';

export const useConceptHotelDetails = (
  slug: string,
  isLocalHotel: boolean,
  conceptHotelInitialData: any
) => {
  const [isClientSide, setIsClientSide] = useState(false);

  useSkipEffectOnMount(() => {
    if (slug && !isClientSide) {
      setIsClientSide(true);
    }
  }, [slug]);

  const {
    data: hotelDetailConceptData,
    isInitialLoading: isConceptLoading,
    isError: isConceptError,
    refetch: refetchConceptHotelData,
  } = useQuery(
    ['hotelDetailConcept', isLocalHotel, slug],
    () =>
      callService(
        {
          service: 'ContentsService',
          method: 'getConceptHotelDetails',
          version: 'v3',
        },
        {
          slug: slug as string,
        }
      ),
    {
      initialData: conceptHotelInitialData,
      enabled: Boolean(slug && isClientSide),
    }
  );
  return {
    hotelDetailConceptData,
    isConceptLoading,
    isConceptError,
    refetchConceptHotelData,
  };
};
